import useMediaQuery from "@mui/material/useMediaQuery";
import { t } from "i18next";
import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";
import PageLayoutWithSidebar from "../../../../../components/PageLayoutWithSidebar";
import config from "../../../../../config";
import QuickServicesWrapper from "./style";

const ServiceRequirement = (props) => {
  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.MOBILE_MAX_WIDTH}px)`
  );
  const navigate = useNavigate();
  const requirementItems = [
    {
      key: "1",
      text: t("quickServices.landPlanningDescriptionServiceRequirement1"),
    },
    {
      key: "2",
      text: t("quickServices.landPlanningDescriptionServiceRequirement2"),
    },
    {
      key: "3",
      text: t("quickServices.landPlanningDescriptionServiceRequirement3"),
    },
  ];


  return (
    <>
      <QuickServicesWrapper>

        <div className="d-flex justify-content-center mx-4">
          <p className="my-0 mx-2 fm-kufi-bold text-sm my-3">
            {t("quickServices.landPlanningTitle")}
          </p>
        </div>

        <PageLayoutWithSidebar className="mt-4">
          <p className="fm-kufi-bold text-sm">
            {t("quickServices.serviceRequirement")}
          </p>
          <ul className="justify-content-between px-3 px-md-4" >
            {requirementItems.map((item) => (
              <li
                key={item.key}
                className="fm-kufi-regular text-sm"
              >
                {item.text}
              </li>
            ))}
          </ul>
        </PageLayoutWithSidebar>

        <div className={`row justify-content-end my-4 ${matches ? "mx-2" : " mx-1"}`}>
          <Button
            onClick={() => navigate("/government-services/dls")}
            className="ant-btn action-btn col-md-2 back-btn  mt-5 justify-content-center text-center fm-kufi-regular text-sm"
          >
            {t("common.back")}
          </Button>
        </div>
      </QuickServicesWrapper>
    </>
  );
};

export default ServiceRequirement;
